function splitCamelCaseToString(inputString:string) {
    return inputString
        .replace(/([A-Z])/g, ' $1')
        .trim();
}
export default splitCamelCaseToString;